import React, { useState, useEffect } from "react";
import { Helmet } from "react-helmet";
import { useForm } from "react-hook-form";
const AddressBook = (props) => {
  const [action, setAction] = useState("add");
  const { handleSubmit, register, errors, getValues } = useForm();
  const addAddressHandler = () => {};
  const editAddressHandler = () => {};
  return (
    <>
      <Helmet>
        {" "}
        <title>eksplode! | Address Book</title>
      </Helmet>
      <div className="dashboard">
        <div className="box-account box-info">
          <div className="box-head">
            <h2>{action === "add" ? "Add" : "Edit"} Address</h2>
          </div>
          <div className="row">
            <div className="col-lg-8 mx-auto my-5 login-page section-b-space">
              <div className="theme-card">
                <form className="theme-form">
                  <div className="form-group">
                    <label htmlFor="street">Street Address</label>
                    <input
                      type="text"
                      className="form-control mb-0"
                      id="street"
                      name="street"
                      placeholder="Street"
                      ref={register({
                        required: {
                          value: true,
                          message: "This Field is Required",
                        },
                      })}
                    />
                    <label htmlFor="street" className="error">
                      {errors.street && errors.street.message}
                    </label>
                  </div>

                  <div className="form-group">
                    <label htmlFor="city">City</label>
                    <input
                      type="text"
                      className="form-control"
                      id="city"
                      placeholder="Enter your City"
                      name="city"
                      ref={register({
                        required: {
                          value: true,
                          message: "This Field is Required",
                        },
                      })}
                    />
                    <label htmlFor="city" className="error">
                      {errors.city && errors.city.message}
                    </label>
                  </div>
                  <div className="form-group">
                    <label htmlFor="state">State</label>
                    <input
                      type="text"
                      className="form-control"
                      id="state"
                      placeholder="Enter your State"
                      name="state"
                      ref={register({
                        required: {
                          value: true,
                          message: "This Field is Required",
                        },
                      })}
                    />
                    <label htmlFor="state" className="error">
                      {errors.state && errors.state.message}
                    </label>
                  </div>
                  <div className="form-group">
                    <label htmlFor="zip">Zip Code</label>
                    <input
                      type="number"
                      className="form-control"
                      id="zip"
                      placeholder="Enter your Zip Code"
                      name="zip"
                      ref={register({
                        required: {
                          value: true,
                          message: "This Field is Required",
                        },
                      })}
                    />
                    <label htmlFor="zip" className="error">
                      {errors.zip && errors.zip.message}
                    </label>
                  </div>
                  <a
                    href="#"
                    className="btn btn-solid"
                    onClick={handleSubmit(
                      action === "add" ? addAddressHandler : editAddressHandler
                    )}
                  >
                    {action === "add" ? "Add" : "Edit"}
                  </a>
                </form>
              </div>
            </div>
          </div>
          <div>
            <div className="box">
              <div className="box-title">
                <h3>Address Book</h3>
              </div>
              <div className="row">
                <div className="col-sm-6">
                  <h6>Default Billing Address</h6>
                  <address>
                    Lorem Ipsum, Dolor, Sitamet - 20000
                    <br />
                    <a
                      href="#"
                      onClick={(e) => {
                        e.preventDefault();
                        setAction("randomid");
                      }}
                    >
                      Edit Address
                    </a>
                  </address>
                </div>
                <div className="col-sm-6">
                  <h6>Default Shipping Address</h6>
                  <address>
                    You have not set a default shipping address.
                    <br />
                    <a
                      href="#"
                      onClick={(e) => {
                        e.preventDefault();
                        setAction("randomid");
                      }}
                    >
                      Edit Address
                    </a>
                  </address>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AddressBook;
